module.exports = __webpack_public_path__ + "ba8b47f239ddb1e036b3e473af058621.jpg";